
<div class="flex flex-col md:flex-row">
    <!--TODO - add element to display when a chart has a render error-->

    <!-- Storage Card - START -->
    <div class="dv-badge flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden mr-2 mb-2">
        <div class="flex items-start justify-between">
            <div class="text-lg font-medium tracking-tight leading-6 truncate">Capacity</div>
        </div>
        <div class="flex flex-col items-center mt-6">
            <div class="text-5xl sm:text-6xl font-bold tracking-tight leading-none text-blue-500">211.2 <span class="text-4xl sm:text-3xl">MB</span></div>
            <div class="text-md font-medium text-blue-600 dark:text-blue-500">Usage in {{ 'Trash' | lpmLabel:'trashLocationLabel' }}</div>
            <div class="flex items-baseline justify-center w-full mt-5 text-secondary">
                <div class="text-md font-medium truncate">File Count:</div>
                <div class="ml-1.5 text-lg font-semibold">33</div>
            </div>
        </div>
    </div>
    <!-- Storage Card - END -->

    <!--Chart 1-->
    <div class="sm:col-span-2 md:col-span-4 lg:col-span-2 flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden max-w-md mr-2 mb-2">
        <div class="flex flex-col sm:flex-row items-start items-center">
            <div class="text-lg font-medium tracking-tight leading-6 truncate">
                File Count
            </div>
            <mat-icon 
                class="icon-size-4 ml-1" 
                matTooltip="Count of files currently within folder, excluding subfolders."
                svgIcon="heroicons_outline:information-circle">
            </mat-icon>
        </div>
        <div class="flex flex-row">
            <!--
            <apx-chart
                class="flex-auto h-80"
                [series]="chartTrashCapacity.series"
                [chart]="chartTrashCapacity.chart"
                [dataLabels]="chartTrashCapacity.dataLabels"
                [plotOptions]="chartTrashCapacity.plotOptions"
                [xaxis]="chartTrashCapacity.xaxis"
                [stroke]="chartTrashCapacity.stroke"
                [fill]="chartTrashCapacity.fill"
                [title]="chartTrashCapacity.title"
                [tooltip]="chartTrashCapacity.tooltip"
                [legend]="chartTrashCapacity.legend">
            </apx-chart>
           -->
        </div>
    </div>
    

    
</div>

